import { HOST } from 'config/config';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';

export default function useImage() {
  return {
    getInventoryItemImage: (entityId, fileId) =>
      `${HOST}/api/dashboard/attached-files/${entityId}/${fileId}/download?type=${BlobStorageTypeEnumValue.InventoryItem}`,
    getInventoryItemVariantImage: (entityId, fileId) =>
      `${HOST}/api/dashboard/attached-files/${entityId}/${fileId}/download?type=${BlobStorageTypeEnumValue.InventoryItemVariant}`,
    getToolingImage: (entityId, fileId) =>
      `${HOST}/api/dashboard/attached-files/${entityId}/${fileId}/download?type=${BlobStorageTypeEnumValue.Tooling}`,
    getExteriorSignageImage: (entityId, fileId) =>
      `${HOST}/api/dashboard/attached-files/${entityId}/${fileId}/download?type=${BlobStorageTypeEnumValue.ExteriorSignage}`,
    getMerchandisingProgramImage: (entityId, fileId) =>
      `${HOST}/api/dashboard/attached-files/${entityId}/${fileId}/download?type=${BlobStorageTypeEnumValue.MerchandisingProgram}`,
    getPanelTypeImage: (entityId, fileId) =>
      `${HOST}/api/dashboard/attached-files/${entityId}/${fileId}/download?type=${BlobStorageTypeEnumValue.PanelType}`,
    getDealerPortalMenuImage: (entityId, fileId) =>
      `${HOST}/api/dashboard/attached-files/${entityId}/${fileId}/download?type=${BlobStorageTypeEnumValue.DealerPortalMenu}`,
  };
}
